import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import { EventService } from '../../../core/services/event.service';

import { TranslateService } from '@ngx-translate/core';

import { LAYOUT_MODE } from "../layouts.model";
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/auth/auth.service';
import { WorkspaceService } from 'src/app/core/services/workspace/workspace.service';
import { TenantUserService } from 'src/app/core/services/TenantUsers/tenantusers.service';
import { Globals } from 'src/app/globals/globals';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/core/services/notifications/notification.service';
import { BrandingService } from 'src/app/core/services/branding/branding.service';
import { Dropdown } from 'primeng/dropdown';
import { environment } from 'src/environments/environment';
import { WorkspaceResolve } from 'src/app/shared/Workspace.resolve';

/** Workspace reloads started; only the latest puts route reuse back (the topbar itself is rebuilt by one). */
let workspaceReloads = 0;

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    standalone: false
})

/**
 * Topbar Component
 */
export class TopbarComponent implements OnInit {

  mode: string | undefined;
  element: any;
  flagvalue: any;
  cookieValue: any;
  countryName: any;
  valueset: any;
  queuesCheck: boolean | undefined;
  workspaceSelectionForm: FormGroup;
  listOfUnreadNotifications: any;
  totalNotifications: any = 0;
  showUnread: boolean = false;
  dashboardViewId: any;
  isLoading: boolean = true;
  accountLogo: string | null = null;
  // Switch Tenant is only meaningful when the user belongs to more than one tenant.
  // Defaults to false so the button stays disabled until the count comes back.
  canSwitchTenant: boolean = false;
  constructor(
    private router: Router,
    public _cookiesService: CookieService,
    public translate: TranslateService,
    private eventService: EventService,
    private authService: AuthenticationService,
    public globals: Globals, private workspaceService: WorkspaceService,
    private tenantuserService: TenantUserService,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private brandingService: BrandingService
  ) { }

  /**
   * Language Listing
   */
  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  layoutMode!: string;

  ngOnInit(): void {
    this.eventService.getQueuesValue().subscribe(res => {
      this.queuesCheck = res;
    });
    this.queuesCheck = JSON.parse(localStorage.getItem('queuesBtn'));
    this.layoutMode = LAYOUT_MODE;
    this.getUnreadMails();
    this.getUnreadCount();
    this.getMyTenantCount();
    this.brandingService.getLogo().subscribe({
      next: (res) => { this.accountLogo = res?.flag && res.data ? res.data : null; },
      error: () => { this.accountLogo = null; }
    });
  }

  getUnreadMails() {
    this.isLoading = true;
    const data = this.showUnread ? { "is_read": false, "is_deleted": false, "sortDirection": 'desc' } : { "is_deleted": false, "sortDirection": 'desc' }
    this.notificationService.getHeaderNotificationData(data, true).subscribe((res) => {
      if (res.flag) {
        this.isLoading = false;
        this.listOfUnreadNotifications = res.data;
      }
    });
  }

  getUnreadCount() {
    this.eventService.data$.subscribe(data => {
      this.totalNotifications = data;

    });
  }




  onSwitchChange() {
    this.getUnreadMails();
  }




  getClass(button: string) {
    if (this.router.url.endsWith(button))
      return 'btn-selected';
  }

  get avatarValue() {
    return this.globals.userData == null || this.globals.userData.name == null
      ? 'U' : this.globals.userData.name.charAt(0);
  }

  get profileName() {
    return this.globals.userData == null || this.globals.userData.name == null
      ? 'USET' : this.globals.userData.name;
  }

  get workspaceOptions() {
    return this.globals.workspaceOptions;
  }

  // Display name of the current TENANT (not the workspace). Comes from the
  // "TenantName" identity-token claim that IdentityServer adds at login;
  // users who logged in before that change must re-login for it to appear.
  get currentTenantName(): string {
    const claims: any = this.globals.userData || {};
    return claims.TenantName || '';
  }



  workspaceChanged(event: any, dropdownRef?: Dropdown) {
    if (dropdownRef) {
      dropdownRef.resetFilter(); // ✅ clears the search input
    }
    // Remember the choice so a refresh comes back here instead of resetting to
    // the first workspace in the list. ngModel has already written the new guid
    // into globals by the time this fires.
    WorkspaceResolve.rememberWorkspace(this.globals.WorkSpaceID);
    this.getWorkspaceActions();
  }

  getWorkspaceActions() {
    this.workspaceService.getMyWorkspaceActions().subscribe(res => {
      if (res.flag) {
        this.globals.workspace_key = res.data.workspace_key;
        this.globals.workspaceActions = res.data.actions;
      }
      else {
        this.globals.workspaceActions = [];
      }
      // Rebuild every component of the current page for the new workspace, on this navigation only: left
      // off, route reuse rebuilt the layout on every later page change, and each rebuilt sidebar kept
      // fetching. navigateByUrl keeps the query string (navigate([url]) encoded its '?' into a 404).
      const reload = ++workspaceReloads;
      const reuse = this.router.routeReuseStrategy;
      reuse.shouldReuseRoute = () => false;
      this.router.navigateByUrl(this.router.url, { onSameUrlNavigation: 'reload' }).finally(() => {
        if (reload === workspaceReloads) delete (reuse as any).shouldReuseRoute;
      });
    });
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }


  onLogout() {
    this.authService.logout();
    localStorage.clear();
  }

  goToAccounts() {
    if(this.globals.isPlatformRole){
        const platformadminUrl = environment.expression_editor_url + '/platformadmin/';
        window.open(platformadminUrl, '_blank');
    }
    else{
        const accountsUrl = environment.expression_editor_url + '/account/';
        window.open(accountsUrl, '_blank');
    }
  }

  // Enable Switch Tenant only for users with access to more than one tenant.
  // The backend returns canSwitchTenant (count > 1); on any failure we leave it
  // disabled - a broken call should never hand a single-tenant user a dead button.
  getMyTenantCount() {
    this.tenantuserService.getMyTenantCount().subscribe({
      next: (res) => {
        this.canSwitchTenant = !!(res?.flag && res.data?.canSwitchTenant);
      },
      error: () => { this.canSwitchTenant = false; }
    });
  }

  selectTenant() {
    try {
      // Clear existing tokens and initiate fresh OAuth flow
      // The identity server will automatically handle single tenant users by redirecting them directly
      // and show tenant selection page only for multi-tenant users
      this.authService.clearOIDCTokens();
      this.authService.configureOAuthAndLogin();
    } catch (error) {
      console.error('Error during tenant selection:', error);
      // Fallback: try a simple logout and re-login
      this.authService.logout();
    }
  }


  openDocs() {
    window.open(environment.docsUrl, '_blank');
  }

  onViewAllPageRoute() {
    const data = {
      guId: null
    };

    this.router.navigate(['/' + this.globals.TenantUniqueKey + '/cloudautomation/notifications'], { state: { data } });
  }

  onSingleView(guId) {

    this.dashboardViewId = guId;
    const data = {
      guId: this.dashboardViewId
    };

    this.router.navigate(['/' + this.globals.TenantUniqueKey + '/cloudautomation/notifications'], { state: { data } });
  }

}
